type scheduleProps = {
  date: string;
  stadium: string;
  name: string;
};

export default function Game(props: scheduleProps) {
  const gameDate = new Date(props.date);
  const gameDay = gameDate?.getDate();
  const gameWeekday = gameDate?.toLocaleDateString("en-US", { weekday: "long" });
  const gameMonth = gameDate?.toLocaleDateString("en-US", { month: "long" });
  const gameTime = gameDate?.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric"
  });

  return (
    <div className="w-full rounded-lg bg-[#1F2731] p-3">
      <div className="font-bold text-lg flex justify-between">
        <p>{props.name}</p>
        <p>{gameTime}</p>
      </div>
      <div className="text-base flex justify-between mt-2">
        <p>{props.stadium}</p>
        <p>
          {gameWeekday}, {gameMonth} {gameDay}
        </p>
      </div>
    </div>
  );
}
